var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5032 4.27472L7.07351 7.7044C6.84446 7.93345 6.71445 8.24918 6.71445 8.57729V14.7619C6.71445 15.4428 7.27162 16 7.9526 16H13.5243C14.0195 16 14.4653 15.7028 14.6634 15.2509L16.6816 10.5398C17.2016 9.31399 16.3039 7.95202 14.9729 7.95202H11.4751L12.0633 5.11666C12.1252 4.80712 12.0323 4.4914 11.8094 4.26853C11.4442 3.90947 10.8623 3.90947 10.5032 4.27472ZM4.23815 16C4.91913 16 5.4763 15.4428 5.4763 14.7619V9.80925C5.4763 9.12827 4.91913 8.5711 4.23815 8.5711C3.55717 8.5711 3 9.12827 3 9.80925V14.7619C3 15.4428 3.55717 16 4.23815 16Z",
    fill: "#1098F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.d5fcbb4d369542d63266d3b60b5a4a97.svg";
export { ForwardRef as ReactComponent };